import * as React from 'react';
import Link from '@mui/joy/Link';

const PasswordResetLink: React.FC = () => {
  const email = 'support@example.com';
  const subject = 'Password Reset Request';
  const body = `Hello,

I would like to reset my password. Please provide the necessary instructions.

Thank you.`;

  return (
    <Link 
      level="title-sm" 
      href={`mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`}
    >
      Mot de passe oublié ?
    </Link>
  );
};

export default PasswordResetLink;